export { Headings } from "./Headings"
